import { DisbursementSource } from '@/models/suba/disbursements/InitiateDisbursementRequest.model';
import { CustodianId } from '@vestwell-sub-accounting/models/common/CustodianId';
import {
  CheckMethod,
  DisbursementCountry,
  DisbursementMethod,
  DisbursementStatus,
  DisbursementType,
  TaxType
} from '@vestwell-sub-accounting/models/common/DistributionRequestTypes';
import { DisbursementRequestQueueStatus } from '@vestwell-sub-accounting/models/common/HoldingTankStatus';
import { IntegrationPartner } from '@vestwell-sub-accounting/models/common/IntegrationPartner';
import { TransactionTypeCode } from '@vestwell-sub-accounting/models/common/TransactionTypeCode';

export enum DisbursementReviewStatus {
  approved = 'approved',
  rejected = 'rejected'
}

export type DisbursementDto = {
  _1099Code: string;
  accountHolderAddress: string;
  accountHolderBirthDate: string;
  accountHolderCity: string;
  accountHolderFederalIdentifier: string;
  accountHolderForeignCountry: DisbursementCountry;
  accountHolderName: string;
  accountHolderState: string;
  accountHolderZip: string;
  additional1099rCode: string;
  amount: string;
  checkAdvice: string | null;
  checkMethod?: CheckMethod | null;
  contributionYear: string | null;
  createdAt: string;
  custodianCheckIssueDate: string | null;
  custodianCheckNumber: string | null;
  custodianId: CustodianId;
  custodianTransactionId: string | null;
  disbursementMethod: DisbursementMethod;
  disbursementSource: DisbursementSource;
  disbursementStatus: DisbursementStatus;
  disbursementType: DisbursementType;
  federalWithholdingPercent: string;
  fromSubAccountId: string;
  furtherCreditToAccountNumber: string | null;
  furtherCreditToName: string | null;
  id: number;
  integrationPartner: IntegrationPartner;
  loanDefaultAmount: string;
  overnightAccountNumber: string;
  parentAccountSourceTransactionId: string | null;
  parentMoneyOutSourceTransactionId: string | null;
  payeeAddress: string;
  payeeCity: string;
  payeeForeignCountry: string;
  payeeName: string;
  payeeState: string;
  payeeZip: string;
  reason: string;
  receivingBankAccountName: string;
  receivingBankAccountNumber: string;
  receivingBankAccountType: string;
  receivingBankName: string;
  receivingBankRoutingNumber: string;
  referenceMemo: string;
  reviewedAt: string | null;
  reviewedBy: string | null;
  reviewedStatus: DisbursementReviewStatus | null;
  rothInitialYear: string;
  rothOrAfterTaxBasisAmount: string;
  rothQualifiedWithdrawal: boolean;
  sourceId: string | null;
  sourceTracerId: string | null;
  stateWithholdingCode: string;
  stateWithholdingPercent: string;
  status: DisbursementRequestQueueStatus;
  subAccountSourceTransactionId: string | null;
  taxType: TaxType | null;
  taxableAmountNotDetermined: boolean;
  taxableRollover?: boolean | null;
  ticketId: string;
  tracerId: string;
  updatedAt: string;
  withdrawalCode: TransactionTypeCode;
};
